import React from 'react';
import { Box, Button } from 'grommet';
import { FormPrevious, FormNext } from 'grommet-icons';
import SHDText from '@ui/Text/SHDText';
import type { SHDCalendarHeaderProps } from './SHDCalendar.d';

const SHDCalendarHeader: React.FC<SHDCalendarHeaderProps> = ({
  date: currentDate,
  className,
  locale,
  onPreviousMonth,
  onNextMonth,
  previousInBound,
  nextInBound,
}) => {
  return (
    <Box
      align="center"
      className={`${className}__header`}
      direction="row"
      justify="between"
      pad={{ bottom: 'small' }}
    >
      <Box className={`${className}__header-title`} pad={{ left: 'xxsmall' }}>
        <SHDText style="subhead-bold">
          {currentDate.toLocaleDateString(locale, {
            month: 'short',
            year: 'numeric',
          })}
        </SHDText>
      </Box>

      <Box
        className={`${className}__header-buttons`}
        direction="row"
        gap="medium"
      >
        <Button
          aria-label="Previous month"
          disabled={!previousInBound}
          onClick={onPreviousMonth}
        >
          <Box>
            <FormPrevious color="primary" />
          </Box>
        </Button>

        <Button
          aria-label="Next month"
          disabled={!nextInBound}
          onClick={onNextMonth}
        >
          <Box>
            <FormNext color="primary" />
          </Box>
        </Button>
      </Box>
    </Box>
  );
};

export default SHDCalendarHeader;
